import React from 'react';

const defaultItems = [
  'Full Service Planning',
  'Day-Of Coordination',
  'Vendor Management',
  'Award-Winning Design',
  'Since 1990',
  'Bespoke Experiences',
  'White-Glove Service',
  'Corporate & Galas',
  'Destination Weddings',
];

const Marquee = ({ items = defaultItems, speed = 42 }) => {
  // duplicate items so the loop seamlessly tiles
  const doubled = [...items, ...items];

  return (
    <div className="relative overflow-hidden">
      {/* Top & bottom hairline borders */}
      <span className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a96e] to-transparent z-10" />
      <span className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a96e] to-transparent z-10" />

      {/* The gold band */}
      <div
        className="relative py-5 md:py-6"
        style={{
          background:
            'linear-gradient(180deg, #d4b478 0%, #e8d5a8 45%, #d8b97e 100%)',
          boxShadow:
            'inset 0 1px 0 rgba(255,250,230,0.5), inset 0 -1px 0 rgba(120,90,40,0.25)',
        }}
      >
        {/* Subtle inner shimmer overlay */}
        <div
          className="absolute inset-0 opacity-25 pointer-events-none"
          style={{
            background:
              'radial-gradient(ellipse at center, rgba(255,250,230,0.6) 0%, transparent 70%)',
          }}
        />

        {/* The moving track */}
        <div
          className="flex whitespace-nowrap will-change-transform"
          style={{
            animation: `marqueeScroll ${speed}s linear infinite`,
            width: 'max-content',
          }}
        >
          {doubled.map((label, i) => (
            <span
              key={`${label}-${i}`}
              className="flex items-center text-black text-[11px] md:text-[12px] tracking-[0.42em] uppercase font-medium px-8 md:px-12"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              <span className="drop-shadow-[0_1px_0_rgba(255,245,220,0.4)]">
                {label}
              </span>
              {/* Decorative diamond separator */}
              <span
                aria-hidden="true"
                className="ml-8 md:ml-12 inline-block w-1.5 h-1.5 rotate-45 bg-black/70"
              />
            </span>
          ))}
        </div>

        {/* Soft edge fades */}
        <span className="absolute top-0 bottom-0 left-0 w-16 md:w-28 z-10 pointer-events-none
                         bg-gradient-to-r from-[#d4b478] to-transparent" />
        <span className="absolute top-0 bottom-0 right-0 w-16 md:w-28 z-10 pointer-events-none
                         bg-gradient-to-l from-[#d4b478] to-transparent" />
      </div>

      <style>{`
        @keyframes marqueeScroll {
          0%   { transform: translate3d(0, 0, 0); }
          100% { transform: translate3d(-50%, 0, 0); }
        }
      `}</style>
    </div>
  );
};

export default Marquee;
